import { render } from "./ImportRevertPopup.vue?vue&type=template&id=594941b2&scoped=true"
import script from "./ImportRevertPopup.vue?vue&type=script&lang=js"
export * from "./ImportRevertPopup.vue?vue&type=script&lang=js"

import "./ImportRevertPopup.vue?vue&type=style&index=0&id=594941b2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594941b2"]])

export default __exports__